import React from 'react'
import styled from 'styled-components'
import { Controller, useForm } from 'react-hook-form'
import {
  DefaultFormErrors,
  useErrors,
  useResetPassword,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { useRouter } from 'next/router'
import { ResetPasswordProps } from './resetPassword.props'
import { Button, FormError, Input, InputLabel } from '../Common'

export const ResetPassword = (_: ResetPasswordProps) => {
  const router = useRouter()
  const {
    errorMessages,
    password: passwordLabels,
    placeholders,
    globalValidations,
    save,
  } = useGlobalLabels()
  const [mutate, { isLoading, error }] = useResetPassword({
    onSuccess: () => router.push('/'),
  })

  const apiErrors = useErrors<DefaultFormErrors>(error, {
    default: errorMessages?.somethingWentWrong,
  })

  const onSubmit = async ({ password }: any) => {
    mutate({
      newPassword: password,
      tokenValue: router.query.token as any,
    })
  }

  const { handleSubmit, errors, control } = useForm({
    defaultValues: {
      password: '',
    },
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  })

  const hasErrors = !Object.keys(errors).length

  return (
    <Container onSubmit={handleSubmit(onSubmit)}>
      <Center>
        <Title>{passwordLabels?.forgottenPassword}</Title>
        <LabelCon>
          <InputLabel>{`${passwordLabels?.pleaseEnterNewPassword}.`}</InputLabel>
        </LabelCon>
      </Center>
      <Controller
        control={control}
        name="password"
        rules={{
          required: globalValidations?.fieldIsRequired,
        }}
        as={
          <Input
            placeholder={placeholders?.newPassword}
            id="new-pass"
            type="password"
          />
        }
      />
      <FormError errors={errors} fieldName="password" />

      <FormError center errors={apiErrors} fieldName="default" />

      <ButtonContainer>
        <Button
          type="submit"
          fullWidth
          variant={hasErrors ? 'green' : 'disabled'}
          disabled={isLoading}
        >
          {save}
        </Button>
      </ButtonContainer>
    </Container>
  )
}

const Title = styled.h3.attrs({
  className: 'mb-2',
})`
  color: ${({ theme }) => theme.palette.silverTree};
`

const Container = styled.form.attrs({
  className: 'container-fluid mt-5 mx-auto',
})`
  max-width: 45rem;
  min-height: calc(100vh - 30rem);
`

const LabelCon = styled.div.attrs({
  className: 'mb-4',
})`
  color: ${({ theme }) => theme.palette.lightgrey};
`

const ButtonContainer = styled.div.attrs({
  className: 'mt-5',
})`
  & [data-btn] {
    font-size: 1.6rem !important;
    padding: 0 !important;
    min-height: 4.4rem !important;
  }
`

const Center = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  & svg {
    height: 2.4rem;
  }
`
